import { createFileRoute } from '@tanstack/react-router';

import { Referrers } from '@/pages/admin/referrers/Referrers';

export const Route = createFileRoute('/admin/_admin/referrers')({
  component: Referrers
});
